module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL3-if-both-wrong.ffdff842.mp3";